/**
 * Notificaciones del navegador (Notification API) para el chat.
 *
 * Funciona mientras la pestaña está abierta (incluso en segundo plano).
 * No requiere Service Worker ni claves VAPID. Para notificaciones con la
 * app totalmente cerrada necesitaríamos PWA + Web Push (futuro).
 */

const PERMISSION_KEY = "dobilas_chat_notify_permission_asked";

export const notificationsSupported = () =>
  typeof window !== "undefined" && "Notification" in window;

export const notificationsEnabled = () =>
  notificationsSupported() && Notification.permission === "granted";

/**
 * Pide permiso al usuario UNA SOLA VEZ por sesión/dispositivo.
 * Devuelve "granted" | "denied" | "default".
 */
export async function ensureNotificationPermission(force = false) {
  if (!notificationsSupported()) return "denied";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  // NOTA SEGURIDAD: este flag NO contiene datos sensibles, sólo un booleano
  // ("1") que indica si ya hemos preguntado al usuario por el permiso de
  // notificaciones. No es candidato a httpOnly cookie ni a cifrado.
  if (!force && localStorage.getItem(PERMISSION_KEY)) return "default";
  localStorage.setItem(PERMISSION_KEY, "1");
  try {
    return await Notification.requestPermission();
  } catch {
    return "default";
  }
}

/**
 * Muestra una notificación nativa. Hace foco en la pestaña al hacer clic.
 */
export function showChatNotification({ title, body, tag, onClick }) {
  if (!notificationsEnabled()) return null;
  // Evita notificaciones cuando el usuario YA está mirando la app activa
  if (typeof document !== "undefined" && document.visibilityState === "visible" && !document.hidden) {
    // Solo si el documento está oculto (otra pestaña, app en background)
    if (document.hasFocus && document.hasFocus()) return null;
  }
  try {
    const n = new Notification(title, {
      body,
      tag,                   // re-usa la misma notif para la misma conv (evita stack)
      renotify: true,
      icon: "/favicon.ico",
      silent: false,
    });
    n.onclick = () => {
      try { window.focus(); } catch { /* ignore */ }
      onClick?.();
      n.close();
    };
    return n;
  } catch {
    return null;
  }
}
